// tslint:disable:object-literal-sort-keys
import React, { useEffect, useState } from "react";

// tslint:disable-next-line:no-submodule-imports
import "react-grid-layout/css/styles.css";
// tslint:disable-next-line:no-submodule-imports
import "react-resizable/css/styles.css";

import "./placeholder.css";

import {
  Layout,
  // Layouts,
  Responsive as ResponsiveGridLayout,
  WidthProvider,
} from "react-grid-layout";

import WidgetCard, { MemoizedWidgetCard } from "./widget-card";

import Highcharts from "highcharts";

import * as _ from "lodash";

const ReactGridLayout = WidthProvider(ResponsiveGridLayout);

// const useStyles = makeStyles((theme: Theme) => createStyles({}));

// https://github.com/STRML/react-grid-layout/issues/1201
// https://codesandbox.io/s/react-responsive-grid-mxux4
// TODO if < lg (&& readonly) use the "new" algorithm
// make sure algorithm for sorting by "layout.y" is stable

interface Props {
  // // saveEntity: any
  // entity?: any // TODO rename to parentEntity?
  // // defaultValues?: any
  // // fields: any
  // fields?: any[]
  // arrayHelpers?: any

  dataSource: any[];
  changeVariables: any;
  loading: boolean;
  totalElements?: number;

  // TODO probably this belongs to the container!
  createEntityMutation?: any;
  updateEntityMutation?: any;
  deleteEntityMutation?: any;

  // TODO naming! (e.g., onViewClick, onEditClick, onDeleteClick)
  onView: any;
  onEdit: any;
  onDelete: any;

  readonly?: boolean;
  onLayoutChange?: (layout: Layout[]) => void;
}

// TODO fields.move on drag&drop!
function WidgetGrid(props: Props) {
  // const { saveEntity, entity, defaultValues/*, match */ } = props;

  // const { entity, fields = /*[]*/entity ? entity.widgets : [], arrayHelpers, readonly } = props;
  const {
    dataSource,
    // changeVariables,
    // loading,
    // totalElements,
    // createEntityMutation,
    // updateEntityMutation,
    // deleteEntityMutation,
    onView,
    onEdit,
    onDelete,
    readonly,
    onLayoutChange,
  } = props;

  const WidgetCardComponent = readonly ? WidgetCard : MemoizedWidgetCard;

  const [mounted, setMounted] = useState(false);
  const [breakpoint, setBreakpoint] = useState("lg");
  const layoutLg: Layout[] = (dataSource || []).map(
    (name: any, index: number) => {
      const w = name;
      const l = w.layout;
      return {
        i: `${w.id || index}`,
        x: l.x,
        y: l.y,
        w: l.width,
        h: l.height,
        minW: l.minWidth || undefined,
        maxW: l.maxWidth || undefined,
        minH: l.minHeight || undefined,
        maxH: l.maxHeight || undefined,
        static: readonly,
      };
    }
  );

  const layouts: { [key: string]: Layout[] } = {
    lg: [...layoutLg],
    md: genLay([...layoutLg], 6),
    sm: genLay([...layoutLg], 6),
    xs: genLay([...layoutLg], 6),
    xxs: genLay([...layoutLg], 2),
  };

  function onBreakpointChange(breakpoint: string) {
    // console.log("onBreakpointChange", breakpoint);
    setBreakpoint(breakpoint);
  }

  useEffect(() => {
    setMounted(true);
  }, []);

  function renderCell(w: any, itm: any, index: number) {
    return (
      <div
        key={`${w.id || index}`}
        style={{
          display: "flex",
          // alignItems: 'stretch'
        }}
        data-grid={itm}
      >
        <WidgetCardComponent
          // entity={entity}
          widget={w}
          // fieldName={name}
          fieldIndex={index}
          // arrayHelpers={arrayHelpers}
          readonly={readonly}
          onView={onView}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      </div>
    );
  }

  return (
    <div>
      <ReactGridLayout
        className="layout"
        rowHeight={30}
        breakpoints={{
          lg: 1200,
          md: 996,
          sm: 768,
          xs: 480,
          xxs: 0,
        }}
        cols={
          readonly
            ? { lg: 12, md: 6, sm: 6, xs: 6, xxs: 2 } // TODO xs 3 vs. 4 vs. 6
            : { lg: 12, md: 12, sm: 12, xs: 12, xxs: 12 }
        }
        layouts={layouts}
        isDraggable={!readonly}
        isResizable={!readonly}
        useCSSTransforms={mounted}
        onLayoutChange={onLayoutChange}
        onBreakpointChange={onBreakpointChange}
        // verticalCompact={true}
        onResize={() => {
          Highcharts.charts.forEach((chart) => {
            // TODO only reflow the current chart
            if (chart) {
              chart.reflow();
            }
          });
        }}
      >
        {!!readonly
          ? layouts[readonly ? breakpoint : "lg"].map(
              (itm: any, index: number) => {
                const w =
                  dataSource.find((d) => d.id === itm.id) || dataSource[index];
                // console.log("widget: ", w, itm);
                return renderCell(w, itm, index);
              }
            )
          : (dataSource || []).map((name: any, index: number) => {
              const w = name;
              const l = w.layout;
              const itm = {
                i: `${w.id || index}`,
                x: l.x,
                y: l.y,
                w: l.width,
                h: l.height,
                minW: l.minWidth || undefined,
                maxW: l.maxWidth || undefined,
                minH: l.minHeight || undefined,
                maxH: l.maxHeight || undefined,
                static: readonly,
              };
              return renderCell(w, itm, index);
            })}
      </ReactGridLayout>
      {/* TODO https://github.com/STRML/react-grid-layout/issues/869 */}
    </div>
  );
}

function sortLay(arr: any[]): any[] {
  return _.sortBy(arr, "y", "x");
}

function getPos(vgrid: any[][], width: number, h: number, col: number): any {
  const w = width > col ? col : width;
  for (let i = 0; i < vgrid.length; i++) {
    for (let j = 0; j < vgrid[i].length; j++) {
      if (!vgrid[i][j]) {
        if (h > i) {
          vgrid.push(Array(col).fill(0));
        }
        if (col - j >= w) {
          // chek height
          let clr = true;
          for (let k = i; k < i + h; k++) {
            // check clr right by w
            if (k > vgrid.length - 1) {
              vgrid.push(Array(col).fill(0));
            }
            for (let m = j; m < w + j - 1; m++) {
              if (vgrid[k][m]) {
                clr = false;
              }
            }
          }
          if (clr) {
            for (let r = i; r < h + i; r++) {
              for (let c = j; c < w + j; c++) {
                // eslint-disable-next-line no-param-reassign
                vgrid[r][c] = 1;
              }
            }
            // console.log("row", i, "col", j);
            return { x: j, y: i, vgrid, w };
          }
        } else {
          break;
        }
      } else {
        vgrid.push(Array(col).fill(0));
      }
    }
  }
}

function genLay(lay: any, col: number): Layout[] {
  const sortedLay = sortLay(lay);
  const nlay: Layout[] = [];
  const nvgrid = Array(Array(col).fill(0));
  for (let i = 0; i < sortedLay.length; i++) {
    const o = { ...sortedLay[i] };
    const { x, y, w } = getPos(nvgrid, o.w, o.h, col);
    // console.log("new pos", "x:", o.x, x, "y: ", o.y, y, "w:", o.w, w);
    o.x = x;
    o.y = y;
    o.w = w;
    nlay.push(o);
  }
  return nlay;
}

export default WidgetGrid;
